import React from 'react';

const BlueLine = () => <div className="blue-line" />;

export default BlueLine;
